/**
 * 功能: 预览报告时, 顶部的样式组件
 */
<template lang="pug">
  div.mainBody
    el-row.main(type="flex")
      el-col.left(type="flex" justify="start")
        p.leftP.line(class="el-icon-arrow-left" @click="goBack")
        p.leftP(style='padding:15px;') {{headerData.title}}
        el-tag.tag(v-for="(tag,index) in headerData.industry" :key="index") {{tag}}
      el-col.right(type="flex" justify="end")
        p.rightP(style="display:inline")
        p.rightP(class="el-icon-time") {{headerData.releaseDate | getTime}}
        p.rightP(class="fa fa-info-circle") version:{{headerData.version}}
</template>

<script>
import { parseTime } from '@/javascripts/time'
export default {
  name: 'Header',
  props: {
    headerData: { type: Object }
  },
  filters: {
    getTime: function (val) {
      if (!val) {
        return '暂无日期'
      }
      const date = new Date(val)
      return parseTime(date, '{y}-{m}-{d}')
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'ReportList' })
    }
  }
}
</script>

<style scoped>
.left{
  width: 1500px;
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:nowrap;
}
.mainBody{
  position: fixed;
  background-color: #fff;
  z-index: 99;
  border-top: 2px solid red;
  width: 100%;
  box-shadow:0 2px 3px -1px gray;
}
.main{
  margin: 0 100px;
}
.right{
  font-size: 14px;
  color: rgb(140, 140, 140)
}
.rightP{
  margin: 0 20px
}
.leftP{
  display: inline;
  font-size: 22px;
  color: black;
  font-weight: 500;
}
.left:hover{
  cursor: pointer;
}
.line{
  border-right: 1px solid #D9D9D9;;
  margin-right: -1px;
  padding-right: 10px;
}
.rightP::before{
  margin: 0 8px 0;
}
.tag{
  margin: 0 5px;
}
</style>
